import authBaseHttpRequest from './authBaseHttpRequest';

// Agency List API
export const fetchAgencyList = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/dashboard/stats/agency-list/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

// Orders API
export const fetchOrders = (payload = {}) => {
  return authBaseHttpRequest({
    method: 'post',
    url: '/dashboard/stats/getOrders/',
    headers: {
      'Content-Type': 'application/json',
    },
    data: payload,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

// Account API
export const fetchAccountDetails = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/dashboard/stats/agency-account/',
    headers: {
      'Content-Type': 'application/json',
    },
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

// Download Agency Template API
export const downloadAgencyTemplate = () => {
  return authBaseHttpRequest({
    method: 'get',
    url: '/download-agency-template/',
    headers: {
      'Content-Type': 'application/json',
    },
    responseType: 'blob', // Important for file downloads
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};

// Upload Agency Funds API
export const uploadAgencyFunds = ({ file }) => {
  const formData = new FormData();
  formData.append('file', file);
  
  return authBaseHttpRequest({
    method: 'post',
    url: '/upload-agency-funds/',
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: formData,
  })
    .then((response) => ({ response: response.data }))
    .catch((error) => ({ error: error.response }));
};
